<template>
    <div>
        <label
            v-if="label"
            class="label text-left">
            <span class="label-text">
                {{ label }}<span
                    v-if="required && !disabled"
                    class="text-error-500 ml-1">
                    *
                </span>
            </span>
        </label>

        <div
            class="border-2 bg-default-100 p-3 pr-1 box-border rounded-2xl flex items-center justify-between relative cursor-pointer"
            :class="{
                'border-info-500': color === 'info' && !disabled,
                'border-success-500': color === 'success' && !disabled,
                'border-warning-500': color === 'warning' && !disabled,
                'border-blue-500': color === 'default' && !disabled,
                'border-info-300': color === 'info' && disabled,
                'border-success-300': color === 'success' && disabled,
                'border-warning-300': color === 'warning' && disabled,
                'border-gray-300': color === 'disabled' && disabled
            }"
            @click="openFormDate">
            <hi-tag-icon
                class="w-6 h-6 absolute top-1 left-1"
                :class="{
                    'text-info-500': color === 'info' && !disabled,
                    'text-success-500': color === 'success && !disabled',
                    'text-warning-500': color === 'warning' && !disabled,
                    'text-blue-500': color === 'default' && !disabled,
                    'text-info-300': color === 'info' && disabled,
                    'text-success-300': color === 'success' && disabled,
                    'text-warning-300': color === 'warning' && disabled,
                    'text-gray-500': color === 'disabled' && disabled
                }" />

            <p
                class="w-full text-default-700 ml-1 leading-5 h-5"
                style="font-size: 10.5px">
                {{ convertDateFormat(cValue) }}
            </p>
            <hts-form-date
                v-if="!disabled"
                ref="formDate"
                v-model="cValue"
                v-model:open="open"
                input-class="hidden"
                class="w-5 cursor-pointer"
                type="datetime"
                time-format="HH:mm"
                :only-date-picker="true"
                :required="required"
                :unix-time="true" />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { DateValue } from '~/components/form/-date-picker/type'

const props = defineProps({
  modelValue: {
    type: [Date, String] as PropType<Date | String | null>,
    default: null,
    required: true
  },
  color: {
    type: String || null,
    default: 'default'
  },
  label: {
    type: String || null,
    default: ''
  },
  required: Boolean,
  disabled: Boolean,
  deleted: {
    type: Boolean,
    default: false
  }
})

const { modelValue, color, label, required } = toRefs(props)

const emits = defineEmits(['update:modelValue', 'handleDelete'])

const formDate = ref()
const open = ref(false)

const cValue = computed<string | number>({
  get () {
    return modelValue.value as string | number
  },
  set (val) {
    emits('update:modelValue', val)
  }
})

const openFormDate = () => {
  open.value = true
}

const closeFormDate = (e: any) => {
  open.value = false
}

const convertDateFormat = (inputDate: string | number): string => {
  if (!inputDate) {
    return ''
  }

  const date = new Date(inputDate)

  if (Number.isNaN(date.getTime())) {
    return ''
  }

  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = String(date.getFullYear())
  const hour = String(date.getHours()).padStart(2, '0')
  const minute = String(date.getMinutes()).padStart(2, '0')

  const formattedDate = `${day}-${month}-${year} ${hour}:${minute}`

  return formattedDate
}
</script>
